var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStandingGroup = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 119 119",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.323 77.004v6.798M27.968 65.117v4.411l10.694 3.089a4.643 4.643 0 0 1 3.113 4.387v23.529M20.13 65.117v4.411L9.435 72.617a4.654 4.654 0 0 0-3.113 4.387v6.798M34.03 80.9v19.633M14.069 80.9v15.41",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M55.58 65.117v4.411l-10.693 3.089a4.654 4.654 0 0 0-3.112 4.387v23.529M69.492 80.9v19.633M49.52 80.9v19.633",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M98.87 65.117v4.411l10.694 3.089a4.643 4.643 0 0 1 3.112 4.387M91.031 65.117v4.411l-10.693 3.089a4.654 4.654 0 0 0-3.113 4.387v23.529M104.943 80.9v15.398M84.97 80.9v19.633M112.677 77.004v6.798",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.694 50.574v4.423l2.317.667M37.855 50.574v4.423l-2.317.667M81.145 50.574v4.423l2.317.667M73.306 50.574v4.423l-2.316.667",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M101.164 100.533h-16.17v11.63",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M69.433 117.159v-16.626H49.52v16.614M59.477 110.477V118",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M33.959 112.14v-11.607H17.836",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M59.067 48.69h.866c4.118 0 7.313 3.591 6.833 7.675l-.433 3.732a6.873 6.873 0 0 1-6.833 6.084 6.874 6.874 0 0 1-6.833-6.084l-.433-3.732c-.48-4.084 2.727-7.675 6.833-7.675Z",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M41.342 33.701h.866c4.118 0 7.312 3.592 6.832 7.675l-.433 3.733a6.873 6.873 0 0 1-6.832 6.084 6.874 6.874 0 0 1-6.833-6.084l-.433-3.733c-.48-4.083 2.726-7.675 6.833-7.675ZM76.793 33.701h.865c4.119 0 7.313 3.592 6.833 7.675l-.433 3.733a6.873 6.873 0 0 1-6.832 6.084 6.874 6.874 0 0 1-6.833-6.084l-.433-3.733c-.48-4.083 2.726-7.675 6.833-7.675ZM59.067 19.604h.866c4.118 0 7.313 3.591 6.833 7.675l-.433 3.732a6.873 6.873 0 0 1-6.833 6.084 6.874 6.874 0 0 1-6.833-6.084l-.433-3.732c-.48-4.084 2.727-7.675 6.833-7.675Z",
  stroke: "#A4ABB7",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M94.296 48.69h.865c4.119 0 7.313 3.591 6.833 7.675l-.433 3.732c-.397 3.475-3.346 6.084-6.832 6.084a6.874 6.874 0 0 1-6.833-6.084l-.433-3.732c-.48-4.084 2.726-7.675 6.833-7.675ZM23.628 48.69h.866c4.118 0 7.312 3.591 6.832 7.675l-.433 3.732a6.873 6.873 0 0 1-6.832 6.084 6.874 6.874 0 0 1-6.833-6.084l-.433-3.732c-.48-4.084 2.726-7.675 6.833-7.675Z",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M63.42 65.117v4.411l10.693 3.089a4.643 4.643 0 0 1 3.112 4.387v23.529",
  stroke: "#F15B35",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M1 59.5C1 27.196 27.196 1 59.5 1S118 27.196 118 59.5",
  stroke: "#5C6471",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgStandingGroup;